import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { tableFilters } from './tableFilters';
import { SolasInfo } from '../types';

export type ParsedSolasInfo = Omit<
  SolasInfo,
  'tipoContenedor' & 'cierreStacking'
> & {
  tipo?: string;
  tamano?: string;
};

type SOLASProps = {
  data?: ParsedSolasInfo[];
  isLoading?: boolean;
};

const SOLAS: FC<SOLASProps> = ({ data, isLoading }) => {
  const tableColumns = getTableColumns(data);

  return (
    <Table
      columns={tableColumns}
      data={data}
      isLoading={isLoading}
      filters={tableFilters}
      paginator
      rows={50}
      autoRowsToFillViewport
      filterDisplay="menu"
      forceRefresh
    />
  );
};

export default SOLAS;
